// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    doesAccountHaveMatch,
    findMatchingKey
} from '../../shared/services/claim-shared-helper';
import {
    readLatestPerUnitMeasurements,
    resetLatestPerUnitMeasurements
} from '../../../shared/action-creators/latest-per-unit-measurements';
import {
    updateNormalClaimInputOnBlur,
    updateResponsibleAccountsDropDown
} from './claim-details';
import actions from '../../action-list';
import {canGetProductCustomer} from '../../../shared/services/privacy';
import {getDetails} from '../../../product/shared/repositories';
import {getUnitKey} from '../../shared/services/get-unit-key';
import {readCustomer} from './get-customer-details';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {updateClaimUseAmountsArray} from '../../shared/services/update-claim-use-amounts-array';
import {updateNonTrackedPinModalPin} from './pin';
import {updateNonTrackedPinModalVisibility} from './non-tracked-pin-modal-visibility';

const updateResponsibleAccount = (accountId, productAccountId, dealerCollection, pin) =>

    dispatch => {

        if (!accountId && doesAccountHaveMatch(productAccountId, dealerCollection)) {

            updateResponsibleAccountsDropDown(productAccountId, dealerCollection, pin)(dispatch);
            dispatch(updateNormalClaimInputOnBlur('responsibleAccount', productAccountId));

        }

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

const openCreatePinModal = (product, dispatch) => {

    if (product.isNonTracked && !product.dealer.account) {

        updateNonTrackedPinModalPin(product.pin)(dispatch);
        updateNonTrackedPinModalVisibility(true)(dispatch);

    }

};

/* eslint-disable complexity */

export const readClaimProduct = (pin, resetUseAmounts) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);

            if (resetUseAmounts) {

                dispatch({
                    type: actions.RESET_CLAIM_NORMAL_USE_AMOUNTS
                });

            }

            openCreatePinModal(data, dispatch);

            const accountId = getState().claims.normal.claim.responsibleAccount.account;
            const dealerCollection = getState().user.details.settings.dealer.accounts.allowedAccounts;
            const productAccountId = data.dealer.account;
            const useAmounts = getState().claims.normal.claim.useAmounts;
            const useAmountUnit = useAmounts.length ?
                useAmounts[0].unit.key : '';

            dispatch({
                data,
                type: actions.SET_CLAIM_NORMAL_PRODUCT_DETAILS
            });

            if (!useAmountUnit && !data.complianceApplies) {

                const unitKey = getUnitKey(data);

                const useAmount = {
                    amount: '',
                    unit: findMatchingKey(unitKey, data.useAmountAllowedUnits)
                };

                dispatch({
                    type: actions.UPDATE_CLAIM_NORMAL_USE_AMOUNT_ON_PRODUCT_LOAD,
                    useAmount
                });

            }

            updateResponsibleAccount(accountId, productAccountId, dealerCollection, pin)(dispatch);

            if (canGetProductCustomer(data)) {

                readCustomer(data.customerSummary.id, data.customerPrivate)(dispatch);

            }

            if (data.complianceApplies) {

                updateClaimUseAmountsArray(useAmounts, data.useAmountAllowedUnits, actions.UPDATE_CLAIM_NORMAL_USE_AMOUNTS)(dispatch);

            }

            readLatestPerUnitMeasurements(pin)(dispatch);

        } catch (error) {

            dispatch({
                type: actions.RESET_CLAIM_NORMAL_PRODUCT_DETAILS
            });

            resetLatestPerUnitMeasurements()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/get-product-details.js